import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { bajaCheque } from "./ApiServices";

export default function ModalBajaCheque({ open, onClose, cheque, onOk }) {
  const [obs, setObs] = useState("");
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open) return;
    setObs("");
    setError("");
  }, [open]);

  const guardar = async () => {
    if (!cheque?.id) return;
    setGuardando(true);
    setError("");
    try {
      await bajaCheque(cheque.id, {
        obs: obs.trim() || undefined,
      });
      onOk?.();
      onClose?.();
    } catch (err) {
      const fallback409 =
        "Solo se puede dar de baja un cheque autorizado. Si aún no fue aceptado, usá Repudiar.";
      setError(
        err.status === 409
          ? err.message || fallback409
          : err.message || "Error al dar de baja el cheque"
      );
    } finally {
      setGuardando(false);
    }
  };

  return (
    <Dialog open={open} onClose={guardando ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        Baja — N° {cheque?.nro_cheque || cheque?.id || ""}
      </DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          {error ? <Alert severity="error">{error}</Alert> : null}
          <Typography variant="body2" color="text.secondary">
            Solo para cheques ya autorizados (aceptados). El cheque deja de
            procesarse, por ejemplo si lo retiraron. Si CC no acepta el eCheq,
            usá Repudiar. El rechazo bancario es otro circuito.
          </Typography>
          <TextField
            label="Observaciones"
            size="small"
            fullWidth
            multiline
            minRows={2}
            value={obs}
            onChange={(e) => setObs(e.target.value)}
            disabled={guardando}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={guardando}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={guardar}
          disabled={guardando}
          startIcon={guardando ? <CircularProgress size={16} color="inherit" /> : null}
        >
          Confirmar baja
        </Button>
      </DialogActions>
    </Dialog>
  );
}
